import './main.css'
import '../App.css'
import { useCallback, useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode, faMap } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../Pages/messageModal';
import { ChevronLeft, Trash2, X, ShoppingBag, Tickets, MapPin, Info } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits } from './common/function';
import { changeAlramModal, checkDuplicateLogins } from '../store';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

function Coupons() {
    const { t } = useTranslation();

    const myData = useSelector((state) => state.myData);
    const mySkin = useSelector((state) => state.mySkin);
    const JWT = useSelector((state) => state.JWT.value);

    const [tab, setTab] = useState(0); // 0: 사용가능, 1: 사용완료
    const [validCoupons, setValidCoupons] = useState([]);
    const [usedCoupons, setUsedCoupons] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate(); // 라우터 이동을 위해 사용


    // 탭에 따른 쿠폰
    const currentCoupons = tab === 0 ? validCoupons : usedCoupons;

    // 쿠폰 클릭 시 => 라우터 이동 (CouponDetail 페이지)
    const handleSelectCoupon = (coupon) => {
        // coupon 데이터를 다음 페이지로 넘길 때 보통 URL 파라미터 + state 조합을 사용합니다.
        // coupon.no(예시)를 파라미터로 사용하고, 나머지는 state로 넘기는 패턴
        navigate(`/couponsDetail/${coupon.no}`, {
            state: { coupon },
        });
    };

    const ListData = async () => {
        try {
            const params = new URLSearchParams();
            params.append("page", "1");
            params.append("take", "100");
            // params.append("telegram_id", myData?.id === 5824942771 || myData?.id === 5859629751 ? "42788815" : String(myData?.id ?? ""));

            const response = await axios.post(
                // 'https://grouper-stirred-widely.ngrok-free.app/exchange-events/coupon/user/list',
                process.env.REACT_APP_API + '/api/exchange-events/coupon/user/list',
                params,
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data?.data ?? [];
            // console.log(tmp);

            setValidCoupons(tmp.filter((coupon) => coupon.uc_pin_status_cd === "01"));
            setUsedCoupons(tmp.filter((coupon) => coupon.uc_pin_status_cd !== "01"));

        } catch (error) {
            if (error?.response?.status === 999) {
                // dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    useEffect(() => {
        // 컴포넌트 마운트 시 쿠폰 목록 불러오기
        ListData();
        // eslint-disable-next-line
    }, []);

    // 만료일까지 남은 일수 계산 함수 (기존과 동일)
    const formatRemainDays = (expireString) => {
        if (!expireString) return '';
        const [datePart] = expireString.split(' ');
        if (!datePart) return '';

        const [yyyy, mm, dd] = datePart.split('-');
        const expireDate = new Date(
            parseInt(yyyy, 10),
            parseInt(mm, 10) - 1,
            parseInt(dd, 10)
        );

        const now = new Date();
        const diffMs = expireDate - now;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
            return '만료';
        }
        return `D-${diffDays + 1}`;
    };

    // 교환 시간 포맷팅 (기존과 동일)
    const formatExchangeTimeRaw = (isoString) => {
        if (!isoString) return '';

        const date = new Date(isoString);
        // UTC+9 보정
        const kst = isoString.includes("T")
            ? new Date(date.getTime())
            : new Date(date.getTime() + 9 * 60 * 60 * 1000);

        const year = kst.getFullYear();
        const month = String(kst.getMonth() + 1).padStart(2, '0');
        const day = String(kst.getDate()).padStart(2, '0');
        const hours = String(kst.getHours()).padStart(2, '0');
        const minutes = String(kst.getMinutes()).padStart(2, '0');
        const seconds = String(kst.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    return (
        <div
            className="friend"
            style={{
                background: "#fff",
                padding: "17px",
                position: "relative"
            }}
        >
            <img
                src="/newImg/banner.jpg"
                style={{
                    position: "absolute",
                    top: "0px",
                    left: "0px",
                    width: "100%"
                }}
            />
            <div
                className="settings-header"
                style={{
                    color: "#000",
                    fontSize: "20px",
                    fontWeight: "bold",
                    lineHeight: "25px",
                    padding: "15px 0",
                    marginTop: "50px",
                    textAlign: "left"
                }}
            >
                {t('coupons_1_0')} <br />
                {validCoupons.length}{t('coupons_1_1')}
            </div>

            {/* 탭 영역 */}
            <div className="coupons-tab">
                <div
                    onClick={() => setTab(0)}
                    className={`coupons-tab-btn ${tab === 0 ? 'active' : ''}`}
                >
                    {t('coupons_2')} {validCoupons.length}
                </div>
                <div
                    onClick={() => setTab(1)}
                    className={`coupons-tab-btn ${tab === 1 ? 'active' : ''}`}
                >
                    {t('coupons_3')} {usedCoupons.length}
                </div>
            </div>

            {/* 2열 그리드 */}
            {
                currentCoupons?.length > 0
                    ?
                    <div className="coupons-grid">
                        {currentCoupons.map((coupon, idx) => (
                            <div
                                key={idx}
                                className="coupon-item"
                                onClick={() => handleSelectCoupon(coupon)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div
                                    className={`coupon-image-wrapper ${coupon.uc_pin_status_cd !== '01' ? 'used' : ''
                                        }`}
                                    style={{ position: 'relative' }}
                                >
                                    {coupon.uc_pin_status_cd === '01' && (
                                        <div className="d-day-badge">
                                            {formatRemainDays(coupon.uc_expire_date)}
                                        </div>
                                    )}

                                    <img
                                        src={coupon.ci_goods_img_big}
                                        alt={coupon.ci_goods_name}
                                        className="coupon-image"
                                        style={{ border: "1px solid #f5f5f5" }}
                                    />

                                    {coupon.uc_pin_status_cd !== '01' && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '0px',
                                                right: '0px'
                                            }}
                                        >
                                            <img
                                                src={
                                                    coupon.uc_pin_status_cd === '03'
                                                        ? '/newImg/unavailable.png'
                                                        : '/newImg/complete.png'
                                                }
                                                alt="used-type"
                                                style={{ width: '65px' }}
                                            />
                                        </div>
                                    )}
                                </div>

                                <div className="coupon-info">
                                    <div className="coupon-company table-overflow-hidden">
                                        {coupon.ci_brand_name}
                                    </div>
                                    <div className="coupon-title table-overflow-hidden">
                                        {coupon.ci_goods_name}
                                    </div>
                                    <div className="coupon-date table-overflow-hidden">
                                        {/* uc_exchange_time -> ex) "2025-05-13T18:53:10.000Z" -> "2025-05-13 18:53:10" */}
                                        {formatExchangeTimeRaw(coupon.uc_exchange_time)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    :
                    <div style={{ width: "100%", marginTop: "30px" }}>
                        <img src={`${process.env.REACT_APP_API}${mySkin.skin_img}`} style={{ width: "150px", marginBottom: "10px" }} />
                        <div style={{ width: "100%", textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#000", marginBottom: '10px' }}>{t('coupons_22')}</div>
                        <div style={{ width: "100%", textAlign: "center", fontSize: "12px", fontWeight: "500", color: "gray" }}>{t('coupons_23')}</div>
                    </div>
            }
        </div>
    );
}

export default Coupons;